import { Analytics, CustomParams, getAnalytics, logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { FirebaseApp, initializeApp } from "firebase/app";

declare let window: any;
export class FireBaseService {
  firebaseConfig: any;

  app: FirebaseApp;

  analytics: Analytics;

  constructor() {
    this.firebaseConfig = {
      apiKey: "AIzaSyCYmRBaSC3684CEVcT0dffQTSr4atVOoYY",
      authDomain: "kuikafirebase.firebaseapp.com",
      projectId: "kuikafirebase",
      storageBucket: "kuikafirebase.appspot.com",
      messagingSenderId: "884605759224",
      appId: "1:884605759224:web:e76096af6fc065f1ed950d",
      measurementId: "G-K00SNWEZVY"
    };
    this.app = initializeApp(this.firebaseConfig);
    this.analytics = getAnalytics(this.app);
  }

  private isAllowedToLog() {
    if (window.location.hostname === "platform.kuika.com") {
      return true;
    }
    return false;
  }

  public logEvent(eventName: string, options?: any) {
    if (this.isAllowedToLog()) {
      const isInternalUser = window?.userInfo?.username?.includes("kuika");
      let opts = options || {};
      if (isInternalUser) {
        opts.internalUser = "1";
      } else {
        opts.internalUser = "0";
      }
      try {
        logEvent(this.analytics, eventName, opts);
      } catch (error) {
        console.log(error);
      }
    }
  }

  public setUserProperties(properties: CustomParams) {
    if (this.isAllowedToLog()) {
      setUserProperties(this.analytics, properties);
    }
  }

  public setUserId(id: string) {
    if (this.isAllowedToLog()) {
      setUserId(this.analytics, id);
    }
  }
}
